import React, { useState } from "react";
import { Checkbox, Modal, ResourceItem, ResourceList, Stack, TextStyle, TopBar, AppProvider } from "@shopify/polaris";
import { LocationTopBar } from "app/setup/modules/operator/features/currency/currencyStyle";
import { withErrorBoundary } from "lib/hoc";
import constant from "lib/constant/constant";

const DEFAULT_APPROVAL = "selected";

const { color } = constant;

const AddVendorApproval = ({ active, activator, vendorList, setVendorList, userInput, setUserInput, setActive, setDisable, cms }) => {
  const [searchValue, setSearchValue] = useState("");
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchList, setSearchList] = useState(vendorList);
  const [tempVendorList, setTempVendorList] = useState([]);

  const theme = {
    colors: {
      topBar: {
        background: color.WHITE,
        backgroundLighter: color.GRAY,
        backgroundDarker: color.ATHENS_GRAY,
        border: color.LOBLOLLY,
        color: color.CLAY,
      },
    },
  };

  const handleSearchChange = (searchItem) => {
    setSearchValue(searchItem);
    setIsSearchActive(searchItem.length > 0);
    const filtered = vendorList.filter(({ _id: code = "", brandName = "" }) => {
      const term = searchItem.toLowerCase();
      return (code?.toLowerCase() ?? "").includes(term.toLowerCase()) ||
        (brandName?.toLowerCase() ?? "").includes(term.toLowerCase());
    });
    setSearchList([...filtered]);
  };

  const handleSearchResultsDismiss = () => {
    setIsSearchActive(false);
    setSearchValue("");
    setSearchList([...vendorList]);
  };

  const handleCheckbox = (index, checked, vendorId) => {
    const updated = [...vendorList];
    updated[index].isCheck = checked;
    setVendorList([...updated]);
    if (checked) {
      setTempVendorList((prev) => [...prev, vendorId]);
    } else {
      setTempVendorList((prev) => prev.filter((id) => id !== vendorId));
    }
  };

  const onSubmit = () => {
    let updated = [...userInput];
    tempVendorList.forEach((vendorId) => {
      const exists = updated.find((item) => item.vendorId === vendorId);
      if (!exists) {
        updated.push({ vendorId, productApproval: DEFAULT_APPROVAL });
      }
    });
    setUserInput([...updated]);
    setTempVendorList([]);
    setActive(false);
    setDisable(false);
  };

  const searchFieldMarkup = (
    <TopBar.SearchField
      onChange={handleSearchChange}
      value={searchValue}
      placeholder="Search Vendors"
      showFocusBorder
    />
  );

  const listToShow = isSearchActive ? searchList : vendorList;

  return (
    <Modal
      open={active}
      onClose={() => setActive(false)}
      title="Add Vendor"
      primaryAction={{ content: cms("common.button.add") || "Add", onAction: onSubmit }}
      secondaryActions={[{ content: cms("common.button.cancel") || "Cancel", onAction: () => setActive(false) }]}
    >
      <Modal.Section>
        <AppProvider theme={theme}>
          <LocationTopBar>
            <TopBar
              showNavigationToggle
              searchResultsVisible={isSearchActive}
              searchField={searchFieldMarkup}
              onSearchResultsDismiss={handleSearchResultsDismiss}
            />
          </LocationTopBar>
          <ResourceList
            resourceName={{ singular: "vendor", plural: "vendors" }}
            items={listToShow}
            renderItem={(item, id, index) => {
              const { _id: vendorId, brandName = "", isCheck = false } = item;
              const isAlreadyAdded = !!userInput.find((u) => u.vendorId === vendorId);
              return (
                <ResourceItem id={vendorId} key={vendorId}>
                  <Stack alignment="center">
                    <Checkbox
                      label=""
                      checked={isCheck || isAlreadyAdded}
                      disabled={isAlreadyAdded}
                      onChange={(checked) => handleCheckbox(index, checked, vendorId)}
                    />
                    <TextStyle>{brandName}</TextStyle>
                  </Stack>
                </ResourceItem>
              );
            }}
          />
        </AppProvider>
      </Modal.Section>
    </Modal>
  );
};

export default withErrorBoundary(AddVendorApproval);
